var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnSearchInGnb = function SvgIcnSearchInGnb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8.4375C1 12.5451 4.32988 15.875 8.4375 15.875C12.5451 15.875 15.875 12.5451 15.875 8.4375C15.875 4.32988 12.5451 1 8.4375 1C4.32988 1 1 4.32988 1 8.4375ZM14.4584 8.4388C14.4584 11.764 11.7628 14.4596 8.43758 14.4596C5.11237 14.4596 2.41675 11.764 2.41675 8.4388C2.41675 5.11359 5.11237 2.41797 8.43758 2.41797C11.7628 2.41797 14.4584 5.11359 14.4584 8.4388Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2075 14.2092C11.9308 13.9326 11.9308 13.4841 12.2075 13.2075C12.4841 12.9308 12.9326 12.9308 13.2092 13.2075L16.3967 16.395C16.6733 16.6716 16.6733 17.1201 16.3967 17.3967C16.1201 17.6733 15.6716 17.6733 15.395 17.3967L12.2075 14.2092Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnSearchInGnb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_search_in_gnb.1684a98d.svg";
export { ForwardRef as ReactComponent };